module.exports = __webpack_public_path__ + "img/arrow-left.16d9768.png";